import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import AttributeItem from 'dashboard/components/AttributeItem';
import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import { Hairline } from 'design-system/variables/effect';

/**
 * Table
 */
export const LabelColumn = styled.div`
  display: -webkit-box;
  overflow: hidden;
  white-space: normal;
  text-overflow: clip;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 20px;
`;

/**
 * Panel
 */
export const ConfigSection = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: ${Hairline.Top};
`;

export const InputLabel = styled(FormControlLabel)`
  font-weight: ${({ theme }) => theme.text.paragraph.md.fontWeight};
`;

export const RequireCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${Color.TextSecondary};
`;

export const AttributeGrid = styled.div<{
  colCount?: number;
}>`
  display: grid;
  grid-column-gap: ${Spacing[4]};
  grid-row-gap: ${Spacing[4]};
  grid-template-columns: ${({ colCount }) => `repeat(${colCount ?? 3}, 1fr)`};

  & + & {
    padding-bottom: ${Spacing[5]};
  }
`;

export const AttributeDisplay = styled(AttributeItem).attrs(() => ({
  titleSpacing: 4,
  wordBreak: 'break-word',
}))``;
